import { Box, Typography, Paper, Divider } from "@mui/material";
import { useParams } from "react-router-dom";

import AppBreadcrumbs from "../../../components/shared/Breadcrumbs/AppBreadcrumbs";
import PageHeader from "../../../components/shared/PageHeader/PageHeader";
// import { FAQ_PAGE_CONFIG } from "./faqPageConfig";

// faqPageConfig.js (or keep in same file)

const FAQ_PAGE_CONFIG = {
  faqs: {
    breadcrumb: "FAQs",
    title: "FAQs",
    description: "Frequently Asked Questions related to CDMP 2026",
    items: [
      {
        id: 1,
        question: "What is CDMP?",
        answer:
          "City Disaster Management Plan (CDMP) is a comprehensive framework for managing disasters at the city level, covering all aspects from prevention to recovery.",
      },
      {
        id: 2,
        question: "What should I do during an earthquake?",
        answer:
          "Drop, Cover, and Hold On. Stay indoors until shaking stops and it's safe to exit. If outdoors, move away from buildings, trees, and power lines.",
      },
      {
        id: 3,
        question: "How can I prepare for disasters?",
        answer:
          "Create an emergency kit, develop a family communication plan, know evacuation routes, and stay informed about local hazards.",
      },
    ],
  },
};


const FaqPage = () => {
  const { section } = useParams();
  const pageData = FAQ_PAGE_CONFIG[section];

  if (!pageData) {
    return <Typography variant="h6">Page not found</Typography>;
  }

  return (
    <Box sx={{ px: { xs: 2, md: 4 }, py: 4, mb: 4 }}>
      {/* Breadcrumb */}
      <AppBreadcrumbs
        items={[
          { label: "Home", path: "/" },
          { label: "About CDMP 2026", path: "/cdmp/documents" },
          { label: pageData.breadcrumb },
        ]}
      />

      {/* Header */}
      <PageHeader
        title={pageData.title}
        description={pageData.description}
      />

      {/* FAQ Container */}
      <Paper
        elevation={0}
        sx={{
          mt: 4,
          p: { xs: 3, md: 4 },
          borderRadius: 3,
          border: "1px solid",
          borderColor: "divider",
          maxWidth: 1100,
        }}
      >
        {pageData.items.map((faq, index) => (
          <Box key={faq.id}>
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{ mb: 1 }}
            >
              {faq.question}
            </Typography>

            <Typography
              sx={{ lineHeight: 1.8, mb: 3 }}
            >
              {faq.answer}
            </Typography>

            {index !== pageData.items.length - 1 && (
              <Divider sx={{ mb: 3 }} />
            )}
          </Box>
        ))}
      </Paper>
    </Box>
  );
};

export default FaqPage;
